/**
 * Sticky Story Gallery — Section JavaScript
 *
 * Handles Theme Editor section lifecycle and ensures sticky offsets
 * remain correct after section load / reorder / resize.
 *
 * Core sticky behaviour is CSS-only via position: sticky + --header-height.
 */

(function () {
  'use strict';

  var SELECTOR = '.sticky-story-gallery';
  var resizeTicking = false;

  function refreshStickyOffset(section) {
    var blocks = section.querySelectorAll('.story-block--sticky .sticky-story-gallery__text-column');
    // Force a style recalculation so sticky top picks up latest --header-height
    blocks.forEach(function (el) {
      el.style.display = 'none';
      void el.offsetHeight;
      el.style.display = '';
    });
  }

  function onResize() {
    if (resizeTicking) return;
    resizeTicking = true;
    requestAnimationFrame(function () {
      document.querySelectorAll(SELECTOR).forEach(refreshStickyOffset);
      resizeTicking = false;
    });
  }

  function initSection(section) {
    refreshStickyOffset(section);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SELECTOR);
    if (section) { /* cleanup handled by DOM removal */ }
  });

  document.addEventListener('shopify:section:reorder', function (e) {
    var section = document.querySelector('#shopify-section-' + e.detail.sectionId);
    if (section && section.querySelector(SELECTOR)) {
      initSection(section.querySelector(SELECTOR));
    }
  });

  window.addEventListener('resize', onResize, { passive: true });

})();
